import { render, staticRenderFns } from "./MenuBusquedaCombos.vue?vue&type=template&id=9ae2a0ec"
import script from "./MenuBusquedaCombos.vue?vue&type=script&lang=js"
export * from "./MenuBusquedaCombos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports